import PropTypes from 'prop-types';
import { Button } from 'antd';
import React from 'react';

const KeyManagerCreateErrorView = ({ displayText, onHideModal }) => (
  <React.Fragment>
    <div id="key-manager-modal-contents">
      <p>{displayText}</p>
      <Button style={{ float: 'right' }} className="button-cancel" type="primary" onClick={onHideModal}>Close</Button>
    </div>
  </React.Fragment>
);

export default KeyManagerCreateErrorView;

KeyManagerCreateErrorView.propTypes = {
  displayText: PropTypes.string.isRequired,
  onHideModal: PropTypes.func.isRequired,
};
